import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HisHtmlUtils } from '../utils';

@Pipe( {
    name: 'hisHtmlUnsafe',
    standalone: false
} )
export class HisHtmlUnsafePipe implements PipeTransform {
    private sanitizer = inject(DomSanitizer);


    transform( html: string ): SafeHtml {
        if ( html ) {
            return this.sanitizer.bypassSecurityTrustHtml( HisHtmlUtils.filterHtml( html ) );
        } else {
            return '';
        }
    }
}
